  function getCallUrl(){
    return 'https://qa.linkfern.com/lang';
    //return 'http://localhost:815/transManage/';
  }

  //全局阿里云图片地址域名
  function getCdnUrl(){
    return 'http://'+domainName()+'/'
  }
  function domainName(){
    return 'img.egolm.com'
  }
  function appKey(){
    //门店系统
    const couponKey="transManage";
    return couponKey;
  }
  function appSystemInfo(){
    const  systemInfo = appKey()+"_systeminfo";
    return systemInfo;
  }
   //取公司标题
  function getCompanyTitle() {
    return '万店便利'
  }
  //取公司电话
  function getCompanyTel() {
    return '021-51721740'
  }
  //取公司地址
  function getCompanyAddress() {
    return '上海市徐汇区枫林路485号枫林创意园区4号楼'
  }
  //取公司邮箱
  function getCompanyEmail() {
    return 'wandian@egolm.com'
  }
  //取公司版权信息
  function getCompanyCopyright () {
    return '©2017 江苏万店易购信息科技有限公司'
  }

  //取版本号
  function getCompanyVersion () {
    return 'V1.0'
  }

  //取备案号
  function getCompanyBeian () {
    return '沪ICP备15000078-1'
  }

  //取网安备案号
  function getCompanyGongBeian () {
    return '沪公网安备 31010402001824号'
  }
  //取网安备案号码
  function getCompanyGongBeianNo () {
    return '31010402001824'
  }
  //帮助中心地址
  function getHelpUrl(){
    return 'http://wiki.egolm.com/wiki/index.php/Ego%2B%E6%96%B0%E9%97%A8%E5%BA%97%E9%9B%B6%E5%94%AEERP'
  }
  //公司网址
  function  getCompanyUrl() {
    return 'http://www.egolm.com/'
  }
  function getDefaultLang(){
    return "zh-CN";//默认语言，zh-CN（中文），en-US（英文）
  }
  var obj = {
    getCallUrl, getCompanyTitle,getCompanyTel,getCompanyAddress,getCompanyEmail,getCompanyCopyright,getDefaultLang,
    getCompanyVersion,getCompanyBeian,getCompanyGongBeian,getCompanyGongBeianNo,getHelpUrl,getCompanyUrl,appKey,appSystemInfo,getCdnUrl,domainName
  }

  if (typeof module !== 'undefined' && typeof exports === 'object') { //使用es5暴露方法
    module.exports = obj;
  } else if (typeof define === 'function' && (define.amd || define.cmd)) {
    define(function() { return obj; });
  } else {
    this.moduleName = obj;
  }



// WEBPACK FOOTER //
// ./static/common.js